export default __webpack_public_path__ + "static/media/zemanat.1846f54e.svg";